/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_GithubInputs */

const id_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const ms_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const da_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const de_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const en_us2_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const es_es2_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const es_mx2_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const fil_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const fr_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const it_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const hu_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const nl_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const no_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const pl_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const pt_br2_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const pt_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const ro_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const fi_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHubissa`)
};

const sv_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const vi_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const tr_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const cs_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const bg_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const ru_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const uk_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const ar_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const hi_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub पर`)
};

const th_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const ja_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const zh_cn2_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const zh_hant1_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const ko_about_github = /** @type {(inputs: About_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

/**
* | output |
* | --- |
* | "GitHub" |
*
* @param {About_GithubInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_github = /** @type {((inputs?: About_GithubInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_GithubInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_github(inputs)
	if (locale === "ms") return ms_about_github(inputs)
	if (locale === "da") return da_about_github(inputs)
	if (locale === "de") return de_about_github(inputs)
	if (locale === "en-US") return en_us2_about_github(inputs)
	if (locale === "es-ES") return es_es2_about_github(inputs)
	if (locale === "es-MX") return es_mx2_about_github(inputs)
	if (locale === "fil") return fil_about_github(inputs)
	if (locale === "fr") return fr_about_github(inputs)
	if (locale === "it") return it_about_github(inputs)
	if (locale === "hu") return hu_about_github(inputs)
	if (locale === "nl") return nl_about_github(inputs)
	if (locale === "no") return no_about_github(inputs)
	if (locale === "pl") return pl_about_github(inputs)
	if (locale === "pt-BR") return pt_br2_about_github(inputs)
	if (locale === "pt") return pt_about_github(inputs)
	if (locale === "ro") return ro_about_github(inputs)
	if (locale === "fi") return fi_about_github(inputs)
	if (locale === "sv") return sv_about_github(inputs)
	if (locale === "vi") return vi_about_github(inputs)
	if (locale === "tr") return tr_about_github(inputs)
	if (locale === "cs") return cs_about_github(inputs)
	if (locale === "bg") return bg_about_github(inputs)
	if (locale === "ru") return ru_about_github(inputs)
	if (locale === "uk") return uk_about_github(inputs)
	if (locale === "ar") return ar_about_github(inputs)
	if (locale === "hi") return hi_about_github(inputs)
	if (locale === "th") return th_about_github(inputs)
	if (locale === "ja") return ja_about_github(inputs)
	if (locale === "zh-CN") return zh_cn2_about_github(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_github(inputs)
	return ko_about_github(inputs)
});
export { about_github as "about.github" }